module.exports = __webpack_public_path__ + "static/media/doc.92ad6013.svg";